import { useTenant } from "../../onboarding/tenant.context.js";
import { TeamEditEnterpriseDialog } from "./team-edit-enterprise-dialog.js";
import type { TeamEditDialogProps } from "./team-edit-flow.js";
import { TeamEditRegularDialog } from "./team-edit-regular-dialog.js";

export const TeamEditDialog = (props: TeamEditDialogProps) => {
  const { type: tenantType } = useTenant();

  return tenantType === "enterprise" ? (
    <TeamEditEnterpriseDialog {...props} />
  ) : (
    <TeamEditRegularDialog {...props} />
  );
};
